import { deLocalizeUrl } from '$lib/paraglide/runtime';

const MARKETING_PATHS = new Set([
	'/',
	'/alquiler-lista-septima',
	'/alquiler-lista-sexta',
	'/zarpar-experiencias',
	'/registro-capitan',
	'/anadir-barco',
	'/regala-zarpar'
]);

/** Canonical pathname (SvelteKit route) from a localized browser URL. */
export function marketingCanonicalPath(pathname: string): string {
	const normalized = pathname.replace(/\/$/, '') || '/';
	return deLocalizeUrl(new URL(normalized, 'https://zarpar.eu')).pathname.replace(/\/$/, '') || '/';
}

/** True when pathname is a marketing redesign page (with optional locale prefix and localized slug). */
export function isMarketingRoute(pathname: string): boolean {
	return MARKETING_PATHS.has(marketingCanonicalPath(pathname));
}

export type NavBarAppearance = 'overlay' | 'marketing' | 'legal' | 'compact';

const LEGAL_PATHS = new Set([
	'/aviso-legal',
	'/politica-de-privacidad',
	'/politica-de-cookies',
	'/terminos-y-condiciones',
	'/terminos-tarjeta-regalo',
	'/preguntas-frecuentes',
	'/contacto'
]);

const OVERLAY_PATHS = new Set(['/', '/anadir-barco']);

/** Top navbar visual style from canonical pathname. */
export function navBarAppearance(pathname: string): NavBarAppearance {
	const canonical = marketingCanonicalPath(pathname);
	if (OVERLAY_PATHS.has(canonical)) return 'overlay';
	if (MARKETING_PATHS.has(canonical)) return 'marketing';
	if (LEGAL_PATHS.has(canonical)) return 'legal';
	return 'compact';
}

/** Sticky sidebar offset matching the active top navbar height. */
export function siteNavHeight(appearance: NavBarAppearance): string {
	switch (appearance) {
		case 'compact':
			return '2.5rem';
		case 'legal':
		case 'marketing':
			return '4.75rem';
		case 'overlay':
			return '0px';
	}
}

/** Hide top navbar on mobile for app-shell and marketplace routes. */
export function hideNavBarTopOnMobile(pathname: string): boolean {
	const canonical = marketingCanonicalPath(pathname);
	return (
		canonical === '/barcos' ||
		canonical.startsWith('/barcos/') ||
		canonical === '/cuenta' ||
		canonical.startsWith('/cuenta/') ||
		canonical === '/admin' ||
		canonical.startsWith('/admin/')
	);
}
